export default __webpack_public_path__ + "static/media/moot-court-6.6c8b5a6f.webp";